import BankIdVerification from '../ui/bankIdVerification';
import bootLayout from 'static/script/app/boot/boot-layout';

export default function(initData) {
    bootLayout(initData);
    BankIdVerification.attachTo('[data-account-locked-verify-bankId]');
}
